import React, { useState, useEffect, useRef } from "react";
import "./invoice.css";
import socket from "../Components/socket";

import { apiRequest } from "../store/allApi";

const Bonushistory = () => {
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  let printRef = useRef(null);

  const [show, setShow] = useState(false);
  const [invoiceData, setInvoiceData] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (e) => {
    setShow(true);
    setInvoiceData(e);
  };

  const [user, setUser] = useState("");

  let limit = 50;
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const role = async () => {
    socket.emit("getprofile");

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest("me", "GET", null, headers);
      setUser(res.data);

      //Allgames(res.data._id)
      Allgames(res.data._id, pageNumber, limit);
    } catch (e) {}
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
  };

  // ALL APIS HERE

  const [cardData, setGame] = useState();

  const Allgames = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    setIsLoading(true);

    try {
      const res = await apiRequest(
        `temp/deposite/${id}?page=${pageNumber}&_limit=${limit}`,
        "GET",
        null,
        headers,
      );
      setGame(res.data.ress);
      {
        // console.log(res.data.ress);
      }

      setNumberOfPages(res.data.totalPages);
      setIsLoading(false);
    } catch (e) {
      {
      }
    }
  };

  useEffect(() => {
    role();
    //eslint-disable-next-line
  }, [pageNumber, limit]);

  const [Withdrawal, setWithdrawal] = useState();
  const [showBottom, setShowBottom] = useState(false);

  const handleCloseBottom = () => setShowBottom(false);
  const handleShowBottom = (data) => {
    setShowBottom(true);
    setWithdrawal(data);
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
    return newDate;
  };
  return (
    <>
      <div>
        <div className="">
          {/* game-cards */}

          {isLoading ? (
            <div className="text-center">
              {cardData && cardData?.length === 0 ? (
                <div className="mt-2">
                  <h3 className="font-weight-bold">No transaction History</h3>
                  <p className="text-muted">
                    You have not made any transaction yet.
                  </p>
                </div>
              ) : (
                <div
                  className="loaderReturn text-center"
                  style={{ zIndex: "99" }}
                >
                  <img
                    src={"/images/LandingPage_img/loader1.gif"}
                    style={{ width: "100%" }}
                  />
                </div>
              )}
            </div>
          ) : (
            cardData &&
            cardData?.length === 0 && (
              <div className="mt-2 text-center">
                <h3 className="font-weight-bold">No transaction History</h3>
                <p className="text-muted">
                  You have not made any transaction yet.
                </p>
              </div>
            )
          )}
        </div>
        {/* new code history  */}

        <div className="transaction_main_section_modal">
          {cardData &&
            cardData
              .filter((card) => card?.Req_type === "bonus") // Only include penalty transactions
              .map((card) => {
                var id = card?._id.toString(),
                  ctr = 0;
                var timestamp = id.slice(ctr, (ctr += 8));
                var machineID = id.slice(ctr, (ctr += 6));
                var processID = id.slice(ctr, (ctr += 4));
                var counter = id.slice(ctr, (ctr += 6));

                var counterid = parseInt(timestamp, 16);

                var titleMsg = "Bonus"; // Always show "Penalty"
                var signIcon = <div className="text-success">(+)</div>;

                return (
                  <div className="bonusCard">
                    <div className="bonusHeader">
                      <div>
                        <h5>🎁 Bonus</h5>
                        <span>
                          {dateFormat(card?.createdAt).split(",")[0]} •{" "}
                          {dateFormat(card?.createdAt).split(",")[1]}
                        </span>
                      </div>

                      <div className="bonusAmount">+₹{card?.amount}</div>
                    </div>

                    <div className="bonusBody">
                      <p>
                        Status :
                        <span className="statusText">
                          Bonus credited successfully
                        </span>
                      </p>

                      <p>
                        Reason :
                        <span className="statusText">
                          {card?.description || card?.txn_msg}{" "}
                        </span>
                      </p>
                    </div>

                    <div className="bonusFooter">
                      Balance : ₹{card?.closing_balance}
                    </div>
                  </div>
                );
              })}
        </div>

        <div></div>
      </div>
    </>
  );
};

export default Bonushistory;
